// =======================================
// DATA TYPES
// =======================================

/**
 * Forgot password flow state
 */
export interface ForgotPasswordState {
  email: string;
  loading: boolean;
  submitted: boolean;
  error: string | null;
}

// =======================================
// CONSTANTS AND OPTIONS
// =======================================

/**
 * Form validation constants
 */
export const VALIDATION_RULES = {
  EMAIL: {
    REQUIRED: 'Email is required',
    INVALID: 'Please enter a valid email address'
  }
} as const;

/**
 * Shown after every submission regardless of whether the email exists,
 * so the form cannot be used to probe which addresses have accounts.
 */
export const SUBMITTED_MESSAGE =
  'If an account exists for that email address, a password reset link has been sent. Check your inbox.';

/**
 * Default state
 */
export const DEFAULT_STATE: ForgotPasswordState = {
  email: '',
  loading: false,
  submitted: false,
  error: null
} as const;
